import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Nursery } from '../models/Nursery';
import { SearchResult } from '../models/SearchResult';

@Injectable()
class SearchResultsService {
  results: BehaviorSubject<Nursery[]>;
  keyWithBestScore: BehaviorSubject<string>;
  nurseryResults: BehaviorSubject<Nursery[]>;
  productResults: BehaviorSubject<SearchResult[]>;
  resultsData: BehaviorSubject<SearchResult[]>;

  constructor() {
    this.results = new BehaviorSubject<Nursery[]>([]);
    this.keyWithBestScore = new BehaviorSubject<string>('');
    this.nurseryResults = new BehaviorSubject<Nursery[]>([]);
    this.productResults = new BehaviorSubject<SearchResult[]>([]);
    this.resultsData = new BehaviorSubject<SearchResult[]>([]);
  }

  public updateResults(nurseries: Nursery[]): void {
    this.results.next(nurseries);
  }

  public updateSearchResults(result) {
    const {
      keyWithBestScore,
      nurseryResults,
      productResults,
      resultsData
    } = result;

    this.keyWithBestScore.next(keyWithBestScore);
    this.nurseryResults.next(nurseryResults);
    this.productResults.next(productResults);
    this.resultsData.next(resultsData);
  }
}

type stuff = {
  keyWithBestScore: string;
  nurseryResults: Nursery[];
  productResults: SearchResult[];
  resultsData: SearchResult[];
};

export { SearchResultsService };
